module.exports = __webpack_public_path__ + "static/media/BLZ-BNB.99709a47.svg";